// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      paddingBottom: 16,
    },
    contentTable: {
      margin: 0,
    },
    searchFormControl: {},
    table: {
      width: '100% !important',
      overflow: 'auto !important',
      '&::-webkit-scrollbar': {
        height: 6,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',

      display: 'flex',
      '& th:first-child': {
        borderTopLeftRadius: 15,
      },
      '& th:last-child': {
        borderTopRightRadius: 15,
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: 15 },
        '& td:last-child': { borderBottomRightRadius: 15 },
      },
      '& tr td:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& tr th:first-child': {
        borderRight: '2px solid #E1E8ED',
      },
      '& tr td + td': {
        borderTop: '2px solid #E1E8ED',
        borderBottom: '2px solid #E1E8ED',
      },
      paddingLeft: 16,
      '& table': {
        width: '100% !important',
        borderRadius: 15,
        marginBottom: 30,
      },
      '& thead': {
        '& tr': {
          maxHeight: 65,
        },
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        innerWidth: 132,
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: '8px 0px 8px 40px',
      },
      '& thead tr th:first-child': {
        padding: '8px 0px 8px 28px',
      },
      '& tbody tr > *': {
        padding: theme.spacing(0, 5),
      },

      '& td': {
        borderBottom: 'none',
        padding: '16px 0px 16px 28px',
        '&:first-child': {
          padding: 0,
          '& > div': {
            padding: '0px 0px 0px 28px',
          },
        },
        '&:last-child': {
          padding: '16px 8px 16px 40px',
        },
      },
    },
    resumeContainer: {
      padding: theme.spacing(1),
    },
    card: {
      background: '#f2f2f2',
      padding: '10px 15px',
      marginBottom: 10,
      borderRadius: 7,
    },
    cardCount: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      marginBottom: 10,
      borderRadius: 7,
    },
    primaryAmount1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryAmount2: {
      color: '#1CBA27',
      fontWeight: 'bold',
    },
    primaryAmount3: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryAmount: {
      marginTop: -5,
      color: '#777',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    sortLabel: {
      color: '#fff !important',
    },
    marginTopTable: {
      marginTop: theme.spacing(2),
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      height: 42,

      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#14171A',
      marginRight: 8,
      marginTop: 1,
    },
    subTiltle: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: 8,
      color: ' #14171A',
      lineHeight: 1,
    },
    value: {
      fontSize: 12,
      color: ' #14171A',
      lineHeight: 1,
    },
    contentTotalEntry: {
      display: 'grid',
      marginRight: 8,
    },
    bodyScroll: {},
    switch: {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track ': {
        background: '#efefef',
      },
      width: 36,
      height: 20,
      padding: 0,
      margin: '0 10px',
      '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: '#0094FF',
            opacity: 1,
            border: 0,
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
          },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
          color: '#33cf4d',
          border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          color: theme.palette.grey[100],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.7,
        },
      },
      '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
      },
      '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#AAB8C2',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
      },
      '& span': {
        color: '#fff',
      },
    },
  }),
);

export default useStyles;
